export interface SseEvent {
  event: string;
  data: Record<string, unknown>;
}

/** Split a text buffer into complete Server-Sent Events. Whatever follows the
 *  last blank line is an event still arriving and comes back as `rest`.
 *  Comment lines (`: ping`) are skipped; a `data` that is not JSON is `{}`. */
export function parseSseChunk(text: string): { events: SseEvent[]; rest: string } {
  const normalized = text.replace(/\r\n/g, '\n');
  const blocks = normalized.split('\n\n');
  const rest = blocks.pop() ?? '';
  const events: SseEvent[] = [];
  for (const block of blocks) {
    let event = 'message';
    const data: string[] = [];
    for (const line of block.split('\n')) {
      if (!line || line.startsWith(':')) continue;
      const i = line.indexOf(':');
      const field = i < 0 ? line : line.slice(0, i);
      const value = i < 0 ? '' : line.slice(i + 1).replace(/^ /, '');
      if (field === 'event') event = value;
      else if (field === 'data') data.push(value);
    }
    if (!data.length) continue;
    let parsed: Record<string, unknown> = {};
    try { parsed = JSON.parse(data.join('\n')) as Record<string, unknown>; } catch { /* keep {} */ }
    events.push({ event, data: parsed });
  }
  return { events, rest };
}
